export const etiquetasCrece = {
  crece: 'crece',
  creceDashboard: 'crece-dashboard',
  crecePaquetes: 'crece-paquetes'
};

// constante que guarde un array creado a partir del objeto de arriba
